exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content{width:100%!important}.modal-content,.mostrar{position:absolute!important}.mostrar{display:list-item!important;opacity:1!important;background-color:rgba(60,41,41,.47843137254901963)!important}.diverror{display:flex;justify-content:center}.text-error{color:red;font-weight:700}", ""]);

// exports
